import api from './api';
import { createSocketCache, waitForUpdate } from '@/api/socketConnection';
import { Trip } from 'common/types/bucket';
import { Expenses } from 'common/types/expenses';
import { Location } from 'common/types/location';
import { TripData } from 'common/types/tripData';
import { createCache } from 'cross-state';

export default new (class {
    get = createSocketCache<Trip, [tripId: string]>({
        async fetch(tripId) {
            const response = await api.get(`/api/buckets/${tripId}`).json();
            const trip = Trip.parse(response);
            return trip;
        },
        onBucketUpdate(bucket, cache) {
            if (bucket.type === 'trip') {
                cache(bucket.id).updateValue(bucket);
            }
        },
        onBucketDelete({ bucketId }, cache) {
            setTimeout(() => cache(bucketId).clear(), 1000);
        },
    });

    locations = createCache(async () => {
        const response = await api.get(`/api/trips/locations`).json();
        return Location.array().parse(response);
    });

    async create(draft: TripData) {
        const response = await api.post(`/api/trips`, { json: draft }).json();
        const trip = Trip.parse(response);
        this.locations.invalidateAll();
        return trip;
    }

    async update(tripId: string, tripData: TripData, expenses: Expenses[]) {
        await waitForUpdate(() => {
            return api.patch(`/api/trips/${tripId}`, { json: { tripData, expenses } }).json();
        });

        this.locations.invalidateAll();
    }

    async addComment(tripId: string, text: string) {
        await waitForUpdate(() => {
            return api.post(`/api/trips/${tripId}/comments`, { json: text }).json();
        });
    }

    async removeReceipt(tripId: string, receiptId: string) {
        await waitForUpdate(() => {
            return api.delete(`/api/trips/${tripId}/receipt/${receiptId}`).json();
        });
    }
})();
